import { FeatureTagSchema } from 'src/models/featureTag/schema';

export const getFeatureTagIdBySlug = (featureTags: FeatureTagSchema[], slug: string) => {
  const targetTag = featureTags.find((f) => f.slug === slug) ?? null;
  if (targetTag) return targetTag.featureTagId;
  return NaN;
};
